import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';
import loansCatalogComponent from './loansCatalog.component';
import loansCatalogCard from './loansCatalogCard/loansCatalogCard';

let loansCatalogModule = angular.module('loansCatalog', [
  uiRouter,
  loansCatalogCard,
])

  .config(($stateProvider) => {
    'ngInject';
    $stateProvider
      .state(STATES.LOANS.LOANS_CATALOG, {
        url: ROUTES.LOANS.LOANS_CATALOG,
        component: 'loansCatalog',
        data: {
          requiresAuth: true,
        },
        resolve: {
          /* @ngInject */
          serviceClosed: (StatusAppCheckers) => StatusAppCheckers.isServiceClosed(),
        },
      });
  })

  .component('loansCatalog', loansCatalogComponent)

  .name;

export default loansCatalogModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansCatalog/loansCatalog.js